
import Check from "rutas/check";
import Casas from "views/casa";
import Ee2Encargado from "views/evaluacion/encargado/ee2";
import RociadoRR2 from "views/evaluacion/encargado/Rociado";

// import DashboardTecnico from 'views/evaluacion/tecnico/Dashboard'

import EvaluacionMunicipal from "views/evaluacion/tecnico/evaluador.municipal"
import EvaluacionMunicipalReportes from "views/evaluacion/tecnico/reportes.ee1";
import Rociado1 from "views/evaluacion/tecnico/rociado1";
import MSDK from "views/maps/m-sdk";

// import Icons from "views/Icons";
import EstratificadoEe2 from "views/estadistica/estratificado/estratificado";
import Rociado1Reportes from "views/evaluacion/tecnico/reportes.rociado1";


var routes = [

  // {
  //   path: "/home",
  //   name: "INICIO",  
  //   icon: "tim-icons icon-chart-pie-36",
  //   component: <DashboardTecnico />,
  //   layout: "/tecnico", 
  // },

  {
    path: "/viviendas",
    name: "Viviendas",
    icon: "tim-icons icon-bank",
    component: <Casas />,  
    layout: "/tecnico",
  },


  // {
  //   path: "/icnon",
  //   name: "Eval. entomologica EE-1",
  //   icon: "tim-icons icon-notes",
  //   component: <Icons />,
  //   layout: "/tecnico",
  // },


  {
    path: "/ee-1-version-2",
    name: "EVALUACION V-2",
    icon: "tim-icons icon-notes",
    component: <EvaluacionMunicipal />,
    layout: "/tecnico",
  },

  {
    path: "/RR1-CH-MA",
    name: "ROCIADO V-2",
    icon: " tim-icons  icon-notes",
    component: <Rociado1 />,
    layout: "/tecnico",
  },

  {
    path: "/reportes-ee-1",
    name: "REPORTES EE-1",
    icon: " tim-icons  icon-cloud-download-93",
    component: <EvaluacionMunicipalReportes />,
    layout: "/tecnico",
  },
  {
    path: "/reportes-rr-1",
    name: "REPORTES RR-1",
    icon: " tim-icons  icon-cloud-download-93",
    component: <Rociado1Reportes />,
    layout: "/tecnico",
  },

  {
    path: "/EE-2",
    name: "CONSOLIDADO EE-2",
    icon: " tim-icons  icon-cloud-download-93",
    component: <Ee2Encargado />,
    layout: "/tecnico",
  },

  {
    path: "/RR2-CH-MA",
    name: "CONSOLIDADO RR-2",
    icon: " tim-icons  icon-cloud-download-93",
    component: <RociadoRR2 />,
    layout: "/tecnico",
  },

  {
    path: "/estratificado",
    name: "Estratificado",
    icon: "tim-icons  icon-cloud-download-93",
    component: <EstratificadoEe2 />,
    layout: "/tecnico",
  },

  {
    path: "/georef",
    name: "Georeferenciaciones",
    icon: "tim-icons icon-pin",
    componet: <Check component={MSDK} />,
    layout: "/tecnico",
  },


];

export default routes;
